import { apiRequest } from '../../apiCall'
import { CallReportRequest } from '../../types/callReport/apiRequestTypes'

export const getCallReport = (params: CallReportRequest) => {
  return apiRequest('CustomerCall.Search', { ...params }, '', true)
}
export const getRecordUrlList = (RecordingId: string) =>
  apiRequest('CustomerCall.RecordUrlList', {}, `?RecordingId=${RecordingId}`)

export const getCallQueueReport = (recordName: string) => {
  return apiRequest('CustomerCall.GetCallReportDetail', {}, `?recordName=${recordName}`)
}
